import { request, request4 } from "@/utils/request";
//   权限管理列表
export const userlist = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManage/userlist",
    data
  });
};
//  添加人员 
export const addUser = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/AuthManage/addUser",
      data
    });
  };
// 冻结
export const lockState = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/AuthManage/lockState",
      data
    });
  };
// 删除用户
export const deleteUser = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/authManage/deleteUser",
      data
    });
  };
// 批量删除用户
export const deleteUserArr = data => {
    return request({
      method: "POST", 
      url: "/api/userAuth/authManage/deleteUserArr",
      data
    });
  };
  // 重置密码 
  export const updateUser = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/AuthManage/updateUser",
      data
    });
  };
  // 权限查询
  export const authAppSelect = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/userAuthManage/authAppSelect",
      data
    });
  };
  //  权限列表
  export const userauthlist = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/userAuthManage/userauthlist",
      data
    });
  };
//查询全部已经勾选的题型ID
  export const authAppAll = data => {
    return request({
      method: "POST",
      url: "/api/userAuth/userAuthManage/authAppAll",
      data
    });
  };
//查询题库一级ID
export const authAppOne = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManage/authAppOne",
    data
  });
};
//查询题库二级ID
export const authAppTwo = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManage/authAppTwo",
    data
  });
};
//查询题库三级ID
export const authAppThree = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManage/authAppThree",
    data
  });
};
//查询合并接口
export const authApp = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManageTopic/authApp",
    data
  });
};
//保存原有的题库权限ID
export const authAppSave = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManage/authAppSave",
    data
  });
};
//保存科室的权限ID
export const saveuserauth = data => {
  return request({
    method: "POST",
    url: "/api/userAuth/userAuthManage/saveuserauth",
    data
  });
};
// 权限列表--资源数
export const listResourceTree = data => {
  return request({
    method: "POST",
    url: "/api/auth/resource/listResourceTree",
    data
  });
};
//已有权限---获取用户资源
export const getUserResource = data => {
  return request({
    method: "POST",
    url: "/api/auth/resource/getUserResource",
    data
  });
};
//更新权限 ---
export const updateUserResource = data => {
  return request({
    method: "POST",
    url: "/api/auth/resource/updateUserResource",
    data
  });
};

export const saveUserInit = data => {
  return request({
    method: "POST",
    url: "/api/auth/init/saveUserInit",
    data
  });
};

export const batchDeleteUserInit = data => {
  return request({
    method: "POST",
    url: "/api/auth/init/batchDeleteUserInit",
    data
  });
};

export const listRoles = data => {
  return request({
    method: "POST",
    url: "/api/auth/role/listRoles",
    data
  });
}; 
//是否初始化医院角色信息
export const isInitHospital = data => {
  return request({
    method: "POST",
    url: "/api/auth/init/isInitHospital",
    data
  });
}; 
//新增医院时初始化角色信息（内置角色改变需要修改代码）
export const initRoleData = data => {
  return request({
    method: "POST",
    url: "/api/auth/init/initRoleData",
    data
  });
}; 
// 获取题库更新提示 /
export const bankSyncLog = data => {
  return request({
    method: 'POST',
    url: `/api/sync/bankSyncLog`,
    data
  })  
}
  // 清除题库提示记录
  export const bankSyncClick = data => {
    return request({
      method: 'POST',
      url: '/api/sync/bankSyncClick',
      data
    })  
  }
